/**
 * 1) Grab the entire header and all <details.mega-menu>
 */
const header = document.querySelector('.header-wrapper');
const detailsItems = header.querySelectorAll('details.mega-menu');
let closeTimer = null;

const closingHandlers = new WeakMap(); // track pending transitionend handlers
const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;

// Initialize transitions when DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  // Force a repaint to ensure transitions are properly registered
  setTimeout(() => {
    document.querySelectorAll('.mega-menu__content').forEach((submenu) => {
      submenu.classList.add('transition-ready');
      // Force a repaint by accessing offsetHeight
      submenu.offsetHeight;
    });
  }, 10);
});

/**
 * fadeOutDetails:
 * Add .closing to the sub-menu, wait for transitionend, then remove [open].
 */
function fadeOutDetails(item) {
  const submenu = item.querySelector('.mega-menu__content');
  if (!submenu) {
    item.removeAttribute('open');
    return;
  }
  // already closing? do nothing
  if (submenu.classList.contains('closing')) return;

  submenu.classList.add('closing');

  const handleTransitionEnd = (evt) => {
    if (evt.target !== submenu) return;
    submenu.removeEventListener('transitionend', handleTransitionEnd);
    closingHandlers.delete(item);
    // If it was reopened meanwhile, abort
    if (!submenu.classList.contains('closing')) return;

    submenu.classList.remove('closing');
    item.removeAttribute('open');
  };

  submenu.addEventListener('transitionend', handleTransitionEnd);
  closingHandlers.set(item, handleTransitionEnd);
}

/**
 * closeAllExcept:
 * For each <details>, if it's not the 'current' one and it's open, fade it out.
 */
function closeAllExcept(current) {
  detailsItems.forEach((d) => {
    if (d !== current && d.hasAttribute('open')) {
      fadeOutDetails(d);
    }
  });
}

function cancelFadeOut(item) {
  const submenu = item.querySelector('.mega-menu__content');
  if (!submenu) return;

  submenu.classList.remove('closing');
  const handler = closingHandlers.get(item);
  if (handler) {
    submenu.removeEventListener('transitionend', handler);
    closingHandlers.delete(item);
  }
}

/**
 * 2) Hover logic for each <details.mega-menu>:
 *    On mouseenter => close others, open this one
 */

if (!isTouch) {
  detailsItems.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      closeAllExcept(item);

      cancelFadeOut(item);
      const submenu = item.querySelector('.mega-menu__content');
      if (submenu) {
        submenu.classList.remove('closing');
        // Force browser to acknowledge the state change
        submenu.offsetHeight;
      }

      // Now open immediately
      item.setAttribute('open', true);
    });
  });
}
if (isTouch) {
  // Tap on the summary toggles this menu, and closes the others
  detailsItems.forEach((item) => {
    const summary = item.querySelector('summary.header__menu-item');
    if (!summary) return;

    summary.addEventListener('click', (e) => {
      e.preventDefault(); // keep it from navigating / interfering with CSS
      const willOpen = !item.hasAttribute('open');

      // close all others
      detailsItems.forEach((d) => {
        if (d !== item && d.hasAttribute('open')) fadeOutDetails(d);
      });

      if (willOpen) {
        const submenu = item.querySelector('.mega-menu__content');
        if (submenu) submenu.classList.remove('closing');
        item.setAttribute('open', '');
      } else {
        fadeOutDetails(item);
      }
    });
  });

  // Tap outside header closes any open menu
  summary.addEventListener('click', (e) => {
    e.preventDefault();
    const willOpen = !item.hasAttribute('open');

    detailsItems.forEach((d) => {
      if (d !== item && d.hasAttribute('open')) fadeOutDetails(d);
    });

    if (willOpen) {
      cancelFadeOut(item); // <— add this
      const submenu = item.querySelector('.mega-menu__content');
      if (submenu) submenu.classList.remove('closing');
      item.setAttribute('open', '');
    } else {
      fadeOutDetails(item);
    }
  });
}

/**
 * 3) If you hover a plain link (like "About"), close any open dropdown with fade-out
 *    - These are top-level links that are NOT inside <details>
 */
const otherLinks = header.querySelectorAll('.header__menu-item.list-menu__item.link:not(details summary)');
otherLinks.forEach((link) => {
  link.addEventListener('mouseenter', () => {
    detailsItems.forEach((d) => {
      if (d.hasAttribute('open')) fadeOutDetails(d);
    });
  });
});

/**
 * 4) If you leave the entire header or leave tabs, fade out everything after a short delay
 */
detailsItems.forEach((item) => {
  let timeout;

  item.addEventListener('mouseenter', () => {
    clearTimeout(timeout);
  });

  item.addEventListener('mouseleave', (e) => {
    // Check if leaving the whole <details> block and submenu
    timeout = setTimeout(() => {
      const submenu = item.querySelector('.mega-menu__content');
      const isHoveringMenuItem = item.matches(':hover');
      const isHoveringSubmenu = submenu && submenu.matches(':hover');

      if (!isHoveringMenuItem && !isHoveringSubmenu) {
        fadeOutDetails(item);
      }
    }, 0);
  });
});

// Global: when you leave the header, schedule closing all open menus
header.addEventListener('mouseleave', () => {
  closeTimer = setTimeout(() => {
    detailsItems.forEach((d) => {
      if (d.hasAttribute('open')) fadeOutDetails(d);
    });
  }, 300); // adjust the delay to taste
});

// If you re-enter the header, cancel any pending close
header.addEventListener('mouseenter', () => {
  if (closeTimer) {
    clearTimeout(closeTimer);
    closeTimer = null;
  }
});

/**
 * 5) Update submenu offset based on the actual height of each menu trigger.
 */
document.addEventListener('DOMContentLoaded', () => {
  const headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;

  const menuItems = headerWrapper.querySelectorAll('.header__menu-item');
  const headerRect = headerWrapper.getBoundingClientRect();

  menuItems.forEach((item) => {
    const itemRect = item.getBoundingClientRect();
    // Calculate the vertical gap from the menu item's bottom to the header's bottom.
    const offset = Math.round(headerRect.bottom) - Math.round(itemRect.bottom);
    // Set the custom property; a positive offset will shift the underline down.
    item.style.setProperty('--underline-shift', `${offset}px`);
  });
});
